import { Outlet } from 'react-router-dom'

import { FeedbackButton } from '@/components/layout/feedback-button'
import { SiteFooter } from '@/components/layout/site-footer'
import { SiteHeader } from '@/components/layout/site-header'

export function AppLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <div className="flex-1">
        <Outlet />
      </div>
      <SiteFooter />
      <FeedbackButton />
    </div>
  )
}
